document.addEventListener('DOMContentLoaded', function () {
  console.log('Globales Skript geladen');

  // Funktion zur Aktualisierung der Warenkorbanzeige
  function updateCartDisplay() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(element => {
          if (cart.item_count > 0) {
            element.textContent = cart.item_count; // Anzahl der Artikel im Warenkorb anzeigen
          } else {
            element.textContent = '0'; // 0 anzeigen, wenn keine Artikel vorhanden sind
          }
        });
      })
      .catch(error => {
        console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
      });
  }

  // Initiale Aktualisierung beim Laden der Seite
  updateCartDisplay();

  // Zusätzliche Aktualisierung, wenn ein Produkt hinzugefügt wurde
  document.querySelectorAll('.add-to-cart , .add-to-cart-button').forEach(button => {
    button.addEventListener('click', function () {
      setTimeout(updateCartDisplay, 500); // Aktualisierung nach kurzer Verzögerung
    });
  });
});
